module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"price-discount-label":{"kvi":"Dauersparpreis"}}}')
  delete Component.options._Ctor
}
